import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M21.7372 5.73712L9.00939 18.4649L3.34229 12.7864L4.75792 11.3736L9.01082 15.6351L20.323 4.32291L21.7372 5.73712Z" fill={ fill || 'currentColor' } />
    </svg>
);
